export default __webpack_public_path__ + "static/xamarin-mobile-application-development-company-peerbits-a7f9329c7691b8a907e517cf29f6d956.png";